import { createContext, useState } from 'react';

export const ClientContext = createContext();
export const ClientProvider = ({ children }) => {
    const [isCreatedClient, setIsCreatedClient] = useState(null);
    const [isEditedClient, setIsEditedClient] = useState(null);
    const [isDeletedClient, setIsDeletedClient] = useState(null);
    const [selectedClient, setSelectedClient] = useState(null);
    
    const addClient = ( value ) => { setIsCreatedClient(value) };
    const editClient = ( value ) => { setIsEditedClient(value) };
    const deleteClient = ( value ) => { setIsDeletedClient(value) };
    const clearSuccess = () => {
        setIsCreatedClient(null);
        setIsDeletedClient(null)
        setIsEditedClient(null)
        setSelectedClient(null)
    }
    const setClient = (client) => { 
        setSelectedClient(client)
    }
    return (
        <ClientContext.Provider value={{ 
            isCreatedClient, 
            addClient, 
            clearSuccess,

            selectedClient,
            setClient,
            
            isDeletedClient,
            deleteClient,

            isEditedClient,
            editClient
            
         }}>
            {children}
        </ClientContext.Provider>
    );
};
